export const ActionTypes = {
  SET_SIDEBAR: "SET_SIDEBAR",
  SET_LOGIN_USER: "SET_LOGIN_USER",
  REMOVE_LOGIN_USER: "REMOVE_LOGIN_USER",
  ADD_AUTHTOKEN: "ADD_AUTHTOKEN",
  REMOVE_AUTHTOKEN: "REMOVE_AUTHTOKEN",
  CHANGE_TENANT: "CHANGE_TENANT",
  RUN_API_MODE: "RUN_API_MODE",
  CANDIDATE_TAB_NUM: "CANDIDATE_TAB_NUM",
  API_ERR_MSG: "API_ERR_MSG",
  USER_ADDRESS: "USER_ADDRESS",
  TENANT_ADMIN_CANDIDATE_TAB: "TENANT_ADMIN_CANDIDATE_TAB",
  CANDIDATE_ROW_CLICK: "CANDIDATE_ROW_CLICK",
  TENANT_INTEGRATION_VIEW: "TENANT_INTEGRATION_VIEW",
  DASHBOARD_VIEW: "DASHBOARD_VIEW",
  PROJECT_DETAILS: "PROJECT_DETAILS",
  UPDATE_PROJECT_LIST: "UPDATE_PROJECT_LIST",
  INCREASE_COUNT: "INCREASE_COUNT",
  SELECTRESOURCETYPE: 'SELECTRESOURCETYPE',
  ALERT_MESSAGE: "ALERT_MESSAGE",
  PROJECT_OVERVIEW: "PROJECT_OVERVIEW",
  COHORT_DATA: "COHORT_DATA",
  COHORT_DATA_COUNT: "COHORT_DATA_COUNT",
  FHIR_META_DATA:"FHIR_META_DATA"

};
